import React, { useEffect, useState } from 'react';
import CustomSlider from '../CustomSlider/CustomSlider';
import CustomModal from '../CustomModal/CustomModal';
import useFileUpload from '../../hooks/useFileUpload';
import useContenutiCorso from '../../hooks/useContenutiCorso';
import { Button, Card, ProgressBar, Spinner } from 'react-bootstrap';
import useMediaQuery from '../../hooks/useMediaQuery';
import { alertService } from '../../services/AlertService';
import ProtectedContent from '../ProtectedContent/ProtectedContent';
import { useNavigate } from 'react-router';
import RichTextEditor from '../RichTextEditor/RichTextEditor';

const ContenutoManager = ({ selectedContenuto, setSelectedContenuto, setReload, contenutiCorso, printAllAree, courseData }) => {
    const {
      handleFileUpload,
      progressUpload,
      statusUpload,
      setSelectedFile,
      isLoadingUploadFile,
      selectedFile
    } = useFileUpload();

    const {
      updateContenuto,
      loadingStateContenutiCorso,
      setModalStateContenuto,
      modalStateContenuto,
      deleteContenuto  
    } = useContenutiCorso();

    const isMax600px = useMediaQuery('(max-width: 600px)');
    const {REACT_APP_REST_ENDPOINT} = process.env;
    const [tipoContenuto, setTipoContenuto] = useState(selectedContenuto && selectedContenuto.tipo_contenuto);
    const [isSelectedOptionalContenuto, setIsSelectedOptionalContenuto] = useState(selectedContenuto && selectedContenuto.opzionale);
    const [formData, setFormData] = useState({});
    const [selectedContenutoObbligatorio, setSelectedContenutoObbligatorio] = useState(selectedContenuto && selectedContenuto?.id_contenuto_propedeutico);
    const [showProtectedContent, setShowProtectedContent] = useState(false);
    const navigate = useNavigate();
    const [editorContent, setEditorContent] = useState('');

    useEffect(() => {
      if (selectedContenuto) {
          setIsSelectedOptionalContenuto(selectedContenuto?.opzionale);
          setSelectedContenutoObbligatorio(selectedContenuto?.id_contenuto_propedeutico)
          setTipoContenuto(selectedContenuto?.tipo_contenuto);
          setFormData(selectedContenuto);
          if(selectedContenuto?.percorso_file && !selectedContenuto.percorso_file?.includes(REACT_APP_REST_ENDPOINT)){
            setFormData(prevState => ({
                ...prevState,
                link_audiovideo: selectedContenuto?.percorso_file || prevState.link_audiovideo || ""
            }));
          }
      }
      if (selectedContenuto?.contenuto) {
          setEditorContent(String(selectedContenuto.contenuto || ''));
      } else {
          setEditorContent('');
      }
  }, [selectedContenuto]);

    const onUpdateContenutoAndUploadFile = async () => {
        let data = {
            ...formData,
            id: formData.id_contenuto,
            titolo: formData.titolo,
            opzionale: isSelectedOptionalContenuto ? 1 : 0,
            peso_orario: +formData.peso_orario,
            id_contenuto_propedeutico: selectedContenutoObbligatorio
        }

        if(tipoContenuto === "Link_Youtube, Vimeo" && formData?.link_audiovideo) {
          let formatoContenuto = "link"
          let urlContenuto = formData?.link_audiovideo
          data = {
            ...data,
            formato_contenuto: formatoContenuto,
            url_contenuto: urlContenuto
          }
        }

        if(isSelectedOptionalContenuto) {
            data.peso_orario = 0;
        } 

        if(!isSelectedOptionalContenuto && data?.peso_orario == "0") {
          alertService.warn("Inserisci un tempo minimo al contenuto", {autoClose: true});
          return;
        }
         await updateContenuto(data, selectedFile);
        
        if(tipoContenuto === "video-pc" || tipoContenuto === "pdf" || tipoContenuto === "documento-testo") {
          await handleFileUpload(selectedContenuto, printAllAree, setSelectedContenuto);
        }

        delete formData?.link_audiovideo;
        if(tipoContenuto === "pdf" || tipoContenuto === "documento-testo") {
          setSelectedContenuto(null);
        }
        if(!selectedFile){
          printAllAree();
          setSelectedContenuto(null);
        } 
    }

    const openModalDeleteContenuto = async () => {
      setModalStateContenuto(state => ({ 
        ...state,
        showModalDeleteContenuto: true, 
       }));
    }

    const onDeleteContenuto = async () => {
        let data = {
          id_contenuto: selectedContenuto?.id_contenuto,
          id_corso: selectedContenuto?.id_corso
        };
        await deleteContenuto(data)
        setSelectedContenuto(null);
        printAllAree();
    }

    const handleCheckboxChange = (isChecked) => {
        setIsSelectedOptionalContenuto(isChecked);
    };

    const handleRadioChange = (event) => {
        setTipoContenuto(event.target.id);
    };

    const handleFormChange = e => {
    const { name, value, type } = e.target;
    if (type === 'file') {
        const file = e.target.files[0];
        if (file) {
          if(name === "video-pc" || name === "pdf" || name === "documentoTesto") {
            setSelectedFile(file);
          } 
        }

    } else {
        setFormData(prevState => ({ ...prevState, [name]: value }));
    }
    };

    const handleEditorChange = (value) => {
        setEditorContent(String(value || ''));
    };

    const renderDeleteContenuto = () => (
        <>
        <span className="d-block fs-4 mb-2"><b>Vuoi eliminare il seguente contenuto?</b> </span>
        <span className="d-block fs-5">{selectedContenuto?.titolo}</span>
        </>
    )

    
  const handleCloseModal = () => {
    setModalStateContenuto(state => ({ 
       ...state,
       showModalDeleteContenuto: false, 
      }));
  }

  const getYoutubeEmbedUrl = (url) => {
    const urlObj = new URL(url);
    const videoId = urlObj.searchParams.get("v");
    return `https://www.youtube.com/embed/${videoId}`;
  }

  const getVimeoEmbedUrl = (url) => {
    const vimeoId = url.split('/').pop();
    return `https://player.vimeo.com/video/${vimeoId}`;
  };

  const getVideoEmbedUrl = (url) => {
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      return getYoutubeEmbedUrl(url);
    } else if (url.includes('vimeo.com')) {
      return getVimeoEmbedUrl(url);
    }
    return null;
  };
  
  
  
  const handleContenutoObbligatorioChange = (event) => {
    setSelectedContenutoObbligatorio(event.target.value);
  }

  const handleNumberInput = (e) => {
    e.target.value = e.target.value.replace(/-/g, '');
  };

  const handleViewContent = () => {
    setShowProtectedContent(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    const processedValue = typeof value === 'object' ? 
      (value !== null ? JSON.stringify(value) : '') : 
      value;

    setSelectedContenuto(prev => ({
      ...prev,
      [name]: processedValue
    }));
  };

    return (
      <>
        {selectedContenuto ? (
          <div className={`container p-3 ${!isMax600px ? "position-relative" : ""} `} style={{height: "100%"}}>
            <div className='row'>
              <div className='col-sm-12 col-md-6 my-3'>
                <span><b>Titolo del contenuto</b></span>
                <hr />
                <input className='form-control' name='titolo' value={formData.titolo || ""} onChange={handleFormChange}/>
              </div>
              <div className='col-sm-12 col-md-3 my-3'>
                <span><b>Opzionale</b></span>
                <hr />
                <div className='mt-4'>
                <CustomSlider 
                    handleSliderChange={handleCheckboxChange}
                    labelText={isSelectedOptionalContenuto ? "Si" : "No"}
                    isChecked={isSelectedOptionalContenuto}
                    />
                </div>
              </div>
              <div className='col-sm-12 col-md-3 my-3'>
                <span><b>Tempo minimo</b></span>
                <hr />
                <div className='d-flex'>
                  <input onInput={handleNumberInput} name='peso_orario' value={!isSelectedOptionalContenuto ? (formData.peso_orario || "") : "0"} onChange={handleFormChange} placeholder='0' type='number' className='form-control' style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}  disabled={isSelectedOptionalContenuto ? true : false}/>
                  <button style={{ cursor: 'default', border: "1px solid #d3d3d3" }}>minuti</button>
                </div>
              </div>
            </div>
            <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
                <span className='d-block'><b>Contenuto obbligatorio</b></span>
                <select value={selectedContenutoObbligatorio || ''} className="form-control" onChange={handleContenutoObbligatorioChange}>
              <option value="">Nessun contenuto</option>
              {contenutiCorso?.map((contenuto) => (
                  contenuto.titolo !== selectedContenuto?.titolo && (
                    <option key={contenuto.id_contenuto} value={contenuto.id_contenuto}>
                      {contenuto.titolo}
                    </option>
                  )
                ))}
            </select>
              </div>
            </div>
             {
               selectedContenuto?.tipo_contenuto === "testo-immagini" && ( 
                <>
                <RichTextEditor
                    name="testo-immagini"
                    value={selectedContenuto?.contenuto || ''}
                    onChange={handleChange}
                    label="Inserisci il testo"
                    placeholder="Inserisci il testo"
                    enableMediaContent={true}
                />
                </>
               )
             }

             {
              selectedContenuto?.tipo_contenuto === "documento-testo" && (
                <>
       <span className="d-block mt-4"><b>Seleziona il file (doc, docx)</b></span>
                <hr />
                 <input type='file' accept=".doc, .docx"  name="documentoTesto" value={formData.documentoTesto} onChange={handleFormChange} className='form-control' /> 
                  {
                    selectedContenuto?.url_contenuto && (
                      <div className='mt-4' style={{paddingBottom: "100px"}}>

                      <span className='d-block'><b>Contenuto attuale</b></span>
                      <Card className='mt-2' style={{ maxWidth: '18rem' }}>
                        <Card.Body>
                          <Card.Title>
                          <i className="bi bi-file-earmark-font text-dark me-1"></i>
                            {selectedContenuto?.titolo}
                          </Card.Title>
                          <Card.Text>
                            Clicca sul pulsante sotto per visualizzare il documento.
                          </Card.Text>
                          <Button variant="primary" onClick={handleViewContent}>
                            Visualizza documento
                          </Button>
                        </Card.Body>
                      </Card>
                      </div>
                    )
                  }
                </>
              )
             }

             {

               selectedContenuto?.tipo_contenuto === "pdf" && ( 
                <>
                <span className="d-block mt-4"><b>Seleziona il pdf</b></span>
                <hr />
                 <input type='file' accept=".pdf" name="pdf" value={formData.pdf} onChange={handleFormChange} className='form-control' /> 
                
                {
                    selectedContenuto?.url_contenuto && ( 
                      <div className='mt-4' style={{paddingBottom: "100px"}}>
                      <span className='d-block'><b>Contenuto attuale</b></span>
                      <Card className='mt-2' style={{ maxWidth: '18rem' }}>
                     <Card.Body>
                    <Card.Title>
                    <i className="bi bi-file-earmark-pdf-fill text-danger me-1"></i>
                      {selectedContenuto?.titolo}
                    </Card.Title>
                    <Card.Text>
                      Clicca sul pulsante sotto per visualizzare il contenuto.
                    </Card.Text>
                    <Button variant="primary" onClick={handleViewContent}>
                      Visualizza contenuto
                    </Button>
                  </Card.Body>
                </Card>
                  </div>
                    )
                }
                </>
               )
             }
             {
               selectedContenuto?.tipo_contenuto === "audio-video" && (
                <>
                <div className="col-12 mt-4">
                <span className="d-block"><b>Seleziona il tipo di contenuto</b></span>
                <hr />
                <div className="form-check my-2">
                <input
                className="form-check-input"
                type="radio"
                name="tipoContenuto"
                id="Link_Youtube, Vimeo"
                value="Link_Youtube, Vimeo"
                checked={tipoContenuto === 'Link_Youtube, Vimeo'}
                onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="Link_Youtube, Vimeo">
                Un video da Youtube o Vimeo
                </label>
            </div>
            <div className="form-check my-2">
                <input
                className="form-check-input"
                type="radio"
                name="tipoContenuto"
                id="video-pc"
                value="video-pc"
                checked={tipoContenuto === 'video-pc'}
                onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="video-pc">
                Un video che ho nel mio computer.
                </label>
            </div>
            </div>
                 
            <div>
              {
                tipoContenuto === "Link_Youtube, Vimeo" && (
                  <div className='my-3'>
                        <input name="link_audiovideo"       
                        value={formData.link_audiovideo || ""}
                        onChange={handleFormChange} placeholder="Incolla l'url qui" className='form-control' type='text'/>
                    </div>
                )
            }   
            {
                tipoContenuto === "video-pc" && (
                    <div className='my-3'>
                        <input accept='.mp3, .mp4' type='file' name="video-pc" value={formData.audiovideo} onChange={handleFormChange} placeholder='Contenuto audio/video' className='form-control' />    
                        <h4 className='mt-3'>{statusUpload}</h4>
                        <ProgressBar
                            striped
                            variant="success"
                            now={progressUpload}
                            label={`${progressUpload?.toFixed(1)}%`}
                        />
                    </div>
                )
            }
             </div> 
             <div className='row' style={{paddingBottom: "100px"}}>
             <div className='col-sm-6'>
            {
              selectedContenuto?.formato_contenuto === "link" && selectedContenuto?.url_contenuto && (
                <>
              <span className='d-block'><b>Contenuto attuale</b></span>
                <iframe
                height="100%"
                src={getVideoEmbedUrl(selectedContenuto?.url_contenuto)}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{maxWidth: "300px"}}
                className='mt-2'
                loading="lazy"
                title="YouTube video player"
              ></iframe>
                </>
              )
            }
            {
              (selectedContenuto?.formato_contenuto === "mp3" || selectedContenuto?.formato_contenuto === "mp4") && selectedContenuto?.url_contenuto && (
                <>
                <span className='d-block'><b>Contenuto attuale</b></span>
                <Card className='mt-2' style={{ maxWidth: '18rem' }}>
                    <Card.Body>
                        <Card.Title>
                            <i className="bi bi-file-earmark-play-fill text-primary me-1"></i>
                            {selectedContenuto?.titolo}
                        </Card.Title>
                        <Card.Text>
                            Clicca sul pulsante sotto per visualizzare il contenuto.
                        </Card.Text>
                        <Button variant="primary" onClick={handleViewContent}>
                            Visualizza contenuto
                        </Button>
                    </Card.Body>
                </Card>
                </>
              )
            }
             </div>
             </div>
                 </>     
              )
            }


            {
              selectedContenuto?.tipo_contenuto === "test" && (
                <div className='mt-4'>
               <button onClick={() => navigate(`/survey-creator`, {state: {courseData: courseData, selectedContenuto: selectedContenuto}})} className='btn btn-primary'>Configura il test</button>
                </div>
              )
            }
      
        <button onClick={openModalDeleteContenuto} className='btn btn-danger btn-lg position-absolute' style={{bottom: "30px", left: "30px"}}>Elimina</button>
        {loadingStateContenutiCorso?.isLoadingContenutoUpdate || isLoadingUploadFile ? 
        <Button variant="primary" disabled className='btn btn-primary btn-lg position-absolute' style={{bottom: "30px", right: "30px"}}>
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
        />
        Caricamento...
       </Button>
        : 
        <button onClick={onUpdateContenutoAndUploadFile} className='btn btn-primary btn-lg position-absolute' style={{bottom: "30px", right: "30px"}}>Salva</button>
        }
       </div>
        ) : null}
         <CustomModal
          show={modalStateContenuto.showModalDeleteContenuto}
          onHide={handleCloseModal}
          headerText="Elimina contenuto"
          size={"md"}
          variant={"danger"}
          btnText={"Elimina"}
          body={renderDeleteContenuto()} 
          isLoading={loadingStateContenutiCorso.isLoadingContenutoDelete}
          closeButton={true}
          onUndoChanges={handleCloseModal}
          onSave={onDeleteContenuto} 
        />
        <ProtectedContent
            show={showProtectedContent}
            onHide={() => setShowProtectedContent(false)}
            selectedContenuto={selectedContenuto}
   /*          url={selectedContenuto?.url_contenuto}
            tipo={selectedContenuto?.tipo_contenuto}
            formatoContenuto={selectedContenuto?.formato_contenuto}
            idContenuto={selectedContenuto?.id_contenuto}
            titolo={selectedContenuto?.titolo} */
        />
      </>
    );
  };
  
export default ContenutoManager